import {
  AfterViewInit,
  Component,
  ElementRef,
  HostListener,
  TemplateRef,
  inject,
} from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-ui-onboarding',
  templateUrl: './ui-onboarding.component.html',
  styleUrls: ['./ui-onboarding.component.scss'],
})
export class UiOnboardingComponent implements AfterViewInit {
  active = 1;
  activeDishPanel = 2;

  isOnboardingSidebarActive = false;
  constructor(private elRef: ElementRef) {}
  viewOnboardingSideBar() {
    const windowWidth = window.innerWidth;
    if (windowWidth < 992) {
      this.isOnboardingSidebarActive = !this.isOnboardingSidebarActive;
    }
  }

  @HostListener('document:click', ['$event'])
  handleOutsideClick(event: Event) {
    if (!this.elRef.nativeElement.contains(event.target)) {
      this.isOnboardingSidebarActive = false;
    }
  }

  selectedPeople = [];

  peoples = [
    { id: 1, name: 'Option 1' },
    { id: 2, name: 'Option 2' },
    { id: 3, name: 'Option 3' },
  ];

  ngAfterViewInit() {}
  typeSelect!: number;
  cuisineSelect!: number;
  priceSelect!: number;
  citySelect!: number;
  websiteSelect!: number;

  businessHoursSelect!: number;

  types = [
    { id: 1, name: 'Restaurant' },
    { id: 2, name: 'Cafe' },
    { id: 3, name: 'Other' },
  ];

  cuisines = [
    { id: 1, name: 'Restaurant' },
    { id: 2, name: 'Cafe' },
    { id: 3, name: 'Other' },
  ];

  prices = [
    { id: 1, name: 'Low' },
    { id: 2, name: 'Mid' },
    { id: 3, name: 'High' },
  ];

  cities = [
    { id: 1, name: 'San-Francisco' },
    { id: 2, name: 'India' },
    { id: 3, name: 'Other' },
  ];

  businessHours = [
    { id: 1, name: 'Mon 12:00 PM - 11:00 AM' },
    { id: 2, name: 'Tue 12:00 PM - 11:00 AM' },
    { id: 3, name: 'Wed 12:00 PM - 11:00 AM' },
  ];

  website = [
    { id: 1, name: 'https://restaurant-sf.com' },
    { id: 2, name: 'Other Domain' },
  ];

  FoodPreviewAdded = false;

  // Modal Code
  private modalService = inject(NgbModal);
  openEditMenuModal(editMenuModal: TemplateRef<any>) {
    this.modalService.open(editMenuModal, {
      windowClass: 'project-modal edit-food-menu-modal',
      centered: true,
    });
  }
  openDeleteMenuItemModal(deleteMenuItemModal: TemplateRef<any>) {
    this.modalService.open(deleteMenuItemModal, {
      windowClass: 'delete-menu-item-modal',
      centered: true,
      size: 'sm',
    });
  }
  openCompleteInfoModal(completeInfoModal: TemplateRef<any>) {
    this.modalService.open(completeInfoModal, {
      windowClass: 'warning-section-modal',
      centered: true,
      size: 'sm',
    });
  }
  openConfirmationModal(confirmationModal: TemplateRef<any>) {
    this.modalService.open(confirmationModal, {
      windowClass: 'warning-section-modal',
      centered: true,
      size: 'sm',
    });
  }
  openAddBusinessHoursModal(addBusinessHoursModal: TemplateRef<any>) {
    this.modalService.open(addBusinessHoursModal, {
      windowClass: 'add-hours-modal',
      centered: true,
    });
  }
}
